import { cn } from "@/design/cn";

/**
 * The Ledger Diamond: Philanthrify's diamond rebuilt as five ledger rows, the detached
 * cell in Verified Green completing the shape (design brief §3.1). The bars use the fixed
 * brand blue (white on the ink sidebar); the verify cell never recolours. Not the
 * per-workspace accent, so the product identity stays constant as workspaces repaint.
 */
export function ImpactLedgerMark({ size = 24, onInk = false }: { size?: number; onInk?: boolean }) {
  const bar = onInk ? "#FFFFFF" : "var(--il-brand)";
  return (
    <svg width={size} height={size} viewBox="0 0 128 128" fill="none" role="img" aria-label="Impact Ledger">
      <rect x="57" y="9" width="14" height="14" rx="7" fill={bar} />
      <rect x="33" y="33" width="62" height="14" rx="7" fill={bar} />
      <rect x="9" y="57" width="80" height="14" rx="7" fill={bar} />
      <rect x="101" y="57" width="18" height="14" rx="7" fill="var(--il-brand-verify)" />
      <rect x="33" y="81" width="62" height="14" rx="7" fill={bar} />
      <rect x="57" y="105" width="14" height="14" rx="7" fill={bar} />
    </svg>
  );
}

/**
 * The product lockup: the mark, the wordmark, and an optional second line carrying the
 * active organisation lens (per §3.2). "Powered by Philanthrify" no longer lives here; it
 * moves to Settings, the public page footer and report covers.
 */
export function ImpactLedgerLogo({
  className,
  lens,
  onInk = false,
  size = 24,
}: {
  className?: string;
  /** Second line: the active organisation lens, e.g. "Stratus Health". */
  lens?: string;
  onInk?: boolean;
  size?: number;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <ImpactLedgerMark size={size} onInk={onInk} />
      <div className="leading-tight">
        <p className={cn("text-[15px] font-semibold tracking-tight", onInk ? "text-white" : "text-ink")}>Impact Ledger</p>
        {lens && <p className={cn("text-[11.5px] font-medium", onInk ? "text-inkText3" : "text-faint")}>{lens}</p>}
      </div>
    </div>
  );
}
